import { oneKlicks } from "../../SDK/oneclick";

export const getMyDoctors = async (hospitalId, page, limit) => {
    const tableSchema = "";
    const tableName = "hospital_doctors";
    const conditions = {
        hospital_id: hospitalId
        // Temporarily removed status filter to see all associations
    };
    const orderBy = "id DESC";
    const search = "";
    const pagination = { page: page, limit: limit };
    const margedata = [
        {
            target_table: "users",
            target_column: "id",
            target_value: "doctor_id",
            target_label: "doctors"
        }
    ];
    console.log('GET MY DOCTORS DATA conditions:', conditions);
    console.log('Fetching from table:', tableName);

    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

    console.log('GET MY DOCTORS DATA raw response:', response);
    console.log('Total doctors found:', response?.data?.length || 0);

    if (response?.data && response.data.length > 0) {
        console.log('First doctor data:', response.data[0]);
        console.log('All doctor status values:', response.data.map(d => ({
            id: d.id,
            doctor_id: d.doctor_id,
            status: d.status,
            status_type: typeof d.status
        })));
    }

    console.log('GET MY DOCTORS DATA before return response controller:', response);
    return response;
}
